import React from 'react';
import Pages from '../mpm-pages';
import Assets from '../mpm-assets';
import { FormattedMessage } from 'react-intl';
import * as Constants from '../mpm-config/Constants';
const Routes = [
  {
    key: 0,
    hidden: true,
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
    children: [
      {
        key: 101,
        path: '/profile/settings',
        component: (props) => <Pages.Profile.Settings key={Date.now()} {...props} />,
        exact: false,
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
      },
      {
        key: 102,
        path: '/profile/notifications',
        component: (props) => <Pages.Profile.Notifications key={Date.now()} {...props} />,
        exact: false,
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
      },
    ],
  },
  {
    key: 1,
    name: <FormattedMessage id="menu.dashboard" />,
    path: '/dashboard',
    icon: Assets.Images.icon_menu_dashboard,
    component: (props) => <Pages.Dashboard key={Date.now()} {...props} />,
    exact: true,
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
  },
  {
    key: 2,
    name: <FormattedMessage id="menu.cession.capture" />,
    icon: Assets.Images.icon_menu_cession_capture,
    path: '/cessions-captures',
    exact: true,
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
    children: [
      {
        key: 21,
        name: <FormattedMessage id="menu.cession.capture.cedant" />,
        path: '/cessions-captures/cedant',
        component: (props) => <Pages.CessionCapture.Cedant key={Date.now()} {...props} />,
        exact: false,
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_ARMATEUR, Constants.ROLE_MAREYEUR],
      },
      {
        key: 22,
        name: <FormattedMessage id="menu.cession.capture.acquereur" />,
        path: '/cessions-captures/acquereur',
        component: (props) => <Pages.CessionCapture.Acequerur key={Date.now()} {...props} />,
        exact: true,
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_MAREYEUR, Constants.ROLE_ARMATEUR, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
      },
    ],
  },
  {
    key: 3,
    name: <FormattedMessage id="menu.cession.product" />,
    path: '/cessions-produits',
    icon: Assets.Images.icon_menu_cesion_produits,
    exact: true,
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
    children: [
      {
        key: 31,
        name: <FormattedMessage id="menu.cession.capture.cedant" />,
        path: '/cessions-produits/cedant',
        component: (props) => <Pages.CessionProduit.Cedant key={Date.now()} {...props} />,
        exact: false,
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_EXPORTATEUR, Constants.ROLE_USINIER],
      },
      {
        key: 32,
        name: <FormattedMessage id="menu.cession.capture.acquereur" />,
        path: '/cessions-produits/acquereur',
        component: (props) => <Pages.CessionProduit.Acequerur key={Date.now()} {...props} />,
        exact: true,
        roles: [Constants.ROLE_ADMIN, Constants.ROLE_USINIER, Constants.ROLE_EXPORTATEUR],
      },
    ],
  },
  {
    key: 4,
    name: <FormattedMessage id="menu.demande.export" />,
    path: '/demande-export',
    icon: Assets.Images.icon_menu_demande_export,
    component: (props) => <Pages.CessionExport key={Date.now()} {...props} />,
    exact: false,
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_EXPORTATEUR],
  },
  {
    key: 5,
    name: <FormattedMessage id="menu.declarations.ventes" />,
    path: '/declarations-ventes',
    icon: Assets.Images.icon_menu_demande_export,
    component: (props) => <Pages.DeclarationVente key={Date.now()} {...props} />,
    exact: false,
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_ARMATEUR],
  },
];

export default Routes;
